/**
 * Efficiently moves an item from one index to another in an array.
 *
 * @param array - The source array
 * @param from - The index of the item to move
 * @param to - The target index where the item should be moved
 * @returns A new array with the item moved, or the same reference if no change
 */
export function arrayMove<T>(array: T[], from: number, to: number): T[] {
  // Return same reference for no-op cases
  if (
    from === to ||
    from < 0 ||
    from >= array.length ||
    to < 0 ||
    to >= array.length
  ) {
    return array;
  }

  // create a shallow copy (immutability)
  const result = array.slice();

  const [item] = result.splice(from, 1); // Remove item from original position
  result.splice(to, 0, item); // Insert item at new position

  return result;
}
